import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useCart } from '../context/CartContext'
import { motion } from 'framer-motion'

const navItems = [
  { to: '/', label: 'Home', end: true },
  { to: '/shop', label: 'Shop' },
  { to: '/blog', label: 'Blog' },
  { to: '/track-order', label: 'Track Order' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' }
]

const navLinkClass = ({ isActive }) =>
  `px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-colors ${
    isActive ? 'bg-fresh-green text-white' : 'text-charcoal hover:bg-charcoal/5'
  }`

const Navbar = () => {
  const { cartCount } = useCart()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <div className="sticky top-4 z-50 px-4">
      <nav className="max-w-4xl mx-auto flex items-center justify-between gap-2 pl-5 pr-2 py-2 rounded-full bg-white/70 backdrop-blur-lg border border-white/50 shadow-xl">
        <Link to="/" className="flex-shrink-0">
          <img src="/brand-logo.webp" alt="Akhtar Sabir Fresh" width={65} height={36} className="h-9 w-auto" />
        </Link>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={navLinkClass}>
              {item.label}
            </NavLink>
          ))}
        </div>

        {/* Cart + Hamburger */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link
            to="/cart"
            id="cart-icon-target"
            aria-label={cartCount > 0 ? `Cart, ${cartCount} item${cartCount === 1 ? '' : 's'}` : 'Cart'}
            className="relative w-10 h-10 rounded-full bg-charcoal/5 hover:bg-charcoal/10 flex items-center justify-center text-charcoal transition-colors"
          >
            <motion.svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
              key={cartCount}
              initial={{ scale: 1 }}
              animate={cartCount > 0 ? { scale: [1, 1.35, 1] } : { scale: 1 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </motion.svg>
            {cartCount > 0 && (
              <span aria-hidden="true" className="absolute -top-1 -right-1 bg-meat-red text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </Link>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-nav-menu"
            className="md:hidden w-10 h-10 rounded-full hover:bg-charcoal/5 flex items-center justify-center text-charcoal transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </nav>

      {isMenuOpen && (
        <div id="mobile-nav-menu" className="md:hidden max-w-4xl mx-auto mt-2 p-2 space-y-1 rounded-2xl bg-white/90 backdrop-blur-lg border border-white/50 shadow-xl">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-2.5 rounded-xl font-semibold transition-colors ${
                  isActive ? 'bg-fresh-green text-white' : 'text-charcoal hover:bg-charcoal/5'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  )
}

export default Navbar